export default __webpack_public_path__ + "static/img_process-5aaa92bc4702858be70c9d8d32070dcd.png";